import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AvBlockingVeilComponent } from '../av-blocking-veil/av-blocking-veil.component';
import { AvRailComponent } from '../av-rail/av-rail.component';
import { LoaderService } from '../../Services/loader.service';
import { waitState } from '../../Services/wait-state.util';

@Component({
  selector: 'av-global-loader',
  standalone: true,
  imports: [AvBlockingVeilComponent, AvRailComponent],
  templateUrl: './global-loader.component.html',
  styleUrl: './global-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalLoaderComponent {
  private readonly _loader = inject(LoaderService);

  protected readonly wait = waitState(this._loader.isLoading);
}
